import api from './api';
import i18n from 'i18next';

/**
 * Get current language
 */
const getLanguage = () => i18n.language?.split('-')[0] || 'en';

/**
 * Authentication service
 */
const authService = {
  /**
   * User login
   */
  async login(email, password) {
    const response = await api.post('/auth/login', { email, password });
    return response.data;
  },

  /**
   * User registration
   */
  async register(email, password) {
    const language = getLanguage();
    const response = await api.post('/auth/register', { email, password, language });
    return response.data;
  },

  /**
   * Request password reset
   */
  async forgotPassword(email) {
    const language = getLanguage();
    const response = await api.post('/auth/forgot-password', { email, language });
    return response.data;
  },

  /**
   * Reset password
   */
  async resetPassword(token, newPassword) {
    const response = await api.post('/auth/reset-password', { token, newPassword });
    return response.data;
  },

  /**
   * Verify email
   */
  async verifyEmail(token) {
    const response = await api.post('/auth/verify-email', { token });
    return response.data;
  },

  /**
   * Resend verification email
   */
  async resendVerification(email) {
    const language = getLanguage();
    const response = await api.post('/auth/resend-verification', { email, language });
    return response.data;
  },

  /**
   * Logout - revoke all refresh tokens
   */
  async logout() {
    const response = await api.post('/auth/logout');
    return response.data;
  },
};

export default authService;
